export default "/_next/static/1b8b66474b22eb8215cc6aff06344f68.png";